module.exports = __webpack_public_path__ + "media/new_order.3805afe4.mp3";